
module dgLogger {
    declare var JL: any;

    interface DgHttpLogRequestConfig extends ng.IRequestConfig {
        msBeforeAjaxCall: number;
        warningAfter: number;
    }

    interface DgHttpLogResponse {
        config: DgHttpLogRequestConfig;
        data: any;
    }

    function dgHttpLoggerInterceptor($q: ng.IQService, $log: ng.ILogService) {
        var urlSeg = "/api/v1";

        function getTimeStamp() {
            return new Date().getHours() + ":" + new Date().getMinutes() + ":" +
                new Date().getSeconds() + ":" + new Date().getMilliseconds();
        }
        return {
            request: (config: DgHttpLogRequestConfig) => {
                config.msBeforeAjaxCall = new Date().getTime();

                if (config.url.slice(0, 7) === urlSeg) {
                    $log.warn(config.url + " start time:" + getTimeStamp());
                }
                    
                return config;
            },

            response: (response: DgHttpLogResponse) => {
                if (response.config.url.slice(0, 7) === urlSeg) {
                    $log.warn(response.config.url + " end time:" + getTimeStamp());
                }

                if (response.config.warningAfter) {
                    var msAfterAjaxCall = new Date().getTime();
                    
                    var timeTakenInMs =
                        msAfterAjaxCall - response.config.msBeforeAjaxCall;
                    if (timeTakenInMs > response.config.warningAfter) {
                        JL('Angular.Ajax').warn({
                            timeTakenInMs: timeTakenInMs,
                            config: response.config,
                            data: response.data
                        });
                    }
                }
                return response;
            },
            responseError: (rejection) => {
                var errorMessage = "timeout";
                if (rejection.status != 0) {
                    errorMessage = typeof (rejection) == 'string' ? rejection : (rejection.data.message || rejection.statusText);
                }
                JL('Angular.Ajax').fatalException({
                    errorMessage: errorMessage,
                    status: rejection.status,
                    config: rejection.config
                }, rejection.data);
                return $q.reject(rejection);
            }
        }
    }

    angular.module('dgLogger')
        .service('dgHttpLoggerInterceptor', dgHttpLoggerInterceptor);
}